import React from "react";

const Checkbox = ({ label, isSelected, onCheckboxChange, info, disabled }) => (
    <div className="crux-cookie-select-form">
        <label className="crux-cookie-select-form-container">
            <input
                type="checkbox"
                name={label}
                checked={isSelected}
                onChange={onCheckboxChange}
                disabled={disabled}
                className="crux-cookie-select-form-check-input"
            />
            <span className="checkmark"></span>
            <span className="crux-cookie-select-title">{label}</span>
        </label>
        <span>
            <span className="crux-cookie-select-info">{info}</span>
            <br />
        </span>
    </div>
);

export default Checkbox;


// WEBPACK FOOTER //
// ./src/Checkbox.js